import React, { useState, useContext } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { ExamsQuestionsModalSubmitted } from './exams-questions-modal-submitted';
import { QuestionBooksContext } from 'src/app/providers/QuestionBooksProvider';
import { useTranslation } from 'react-i18next';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Sheet, SheetBody, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { CardKpi, CardKpiGrid } from '@/components/ui/card';

export function ExamsQuestionsModalEnd(props) {
  const { questionBooksUser, show, onClose, questionBook, questions, countAnswered, countCorrectAnswers, finishQuestionBook, elapsedTime, formattedDate } = props;
  const { t } = useTranslation();
  const client = useClient();
  const [showModal, setShowModal] = useState(false);
  const { setCorrectAnswers } = useContext(QuestionBooksContext);

  const handleFinalizeExam = async () => {
    const { error } = await client.mutate(['question_books_users', questionBooksUser?.id], { done: true });
    if (error) {
      toast.error(response.error.title);
    } else {
      setShowModal(true);
      onClose();
    }
  };

  const handleSaveAnswers = async () => {
    setCorrectAnswers(countCorrectAnswers());
  };

  function convertToMinutes(elapsedTime) {
    return Math.floor(elapsedTime / 60);
  }

  const elapsedTimeInMinutes = Math.floor(elapsedTime / 60);

  return (
    <>
      <Sheet
        open={show}
        onOpenChange={onClose}
      >
        <SheetContent size="md">
          <SheetBody className="pb-6 pt-12">
            <SheetTitle>{t('exams.submitExam')}</SheetTitle>

            <p className="mb-4">{t('exams.subtitleSubmitExam')}</p>

            <CardKpi className="!mb-3 !justify-start !pl-4">
              <FiCheckCircle />{' '}
              <span className="font-light">
                <strong>
                  {countAnswered()}/{questions.length}
                </strong>{' '}
                - {t('exams.submitedQuestions')}
              </span>
            </CardKpi>

            <CardKpiGrid className="max-sm:grid-cols-1">
              <Button
                variant="outline"
                wide
                onClick={onClose}
              >
                {t('button.notFinish')}
              </Button>

              <Button
                wide
                onClick={handleFinalizeExam}
              >
                {t('button.submitAndFinish')}
              </Button>
            </CardKpiGrid>
          </SheetBody>
        </SheetContent>
      </Sheet>

      <ExamsQuestionsModalSubmitted
        formattedDate={formattedDate}
        elapsedTimeInMinutes={elapsedTimeInMinutes}
        countAnswered={countAnswered}
        show={showModal}
        onSave={handleSaveAnswers}
        questionBook={questionBook}
        questions={questions}
        finishQuestionBook={finishQuestionBook}
      />
    </>
  );
}
